import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCopy = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 23",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M13.334 19.6667H2.50065V5.58342C2.50065 4.98758 2.01315 4.50008 1.41732 4.50008C0.821484 4.50008 0.333984 4.98758 0.333984 5.58342V19.6667C0.333984 20.8584 1.30898 21.8334 2.50065 21.8334H13.334C13.9298 21.8334 14.4173 21.3459 14.4173 20.7501C14.4173 20.1542 13.9298 19.6667 13.334 19.6667ZM18.7507 15.3334V2.33341C18.7507 1.14175 17.7757 0.166748 16.584 0.166748H6.83398C5.64232 0.166748 4.66732 1.14175 4.66732 2.33341V15.3334C4.66732 16.5251 5.64232 17.5001 6.83398 17.5001H16.584C17.7757 17.5001 18.7507 16.5251 18.7507 15.3334ZM16.584 15.3334H6.83398V2.33341H16.584V15.3334Z" })
});
export default SvgCopy;
